<template>
  <div class="Radio is--radio">
    <input
      type="radio"
      :id="id"
      :name="name"
      :checked="modelValue === value"
      :value="value"
      @change="$emit('update:modelValue', value)"
      :required="!!required"
    />
    <span class="Radio__custom"></span>
    <label class="Radio__label" :for="id">{{ label }}</label>

  </div>
</template>

<script>
  export default {
    props: ['settings', 'name', 'modelValue', 'required', 'error', 'errors'],

    setup(props) {
      const { id, label, checked, value } = props.settings
      return { id, label,checked, value }
    },
  }
</script>

<style lang="scss">
  @import "~@sass/components/form/_Radio.scss";
</style>
